import React from "react";
import { Types } from "../../../types/types";
import styles from "./MovieCard.module.scss";
import { formatEventDateTimeMin } from "../../../utils/formatDate";

interface Props {
  event: Types;
}

const MovieCard: React.FC<Props> = ({ event }) => {
  const { date, time } = formatEventDateTimeMin(
    event.date_start,
    event.date_end
  );

  return (
    <div className={styles.card}>
      {event.is_finished && <div className={styles.cardDisabled} />}
      <img src={event.imageUrl} alt={event.name} className={styles.image} />

      <div className={styles.content}>
        <div className={styles.textcontent}>
          <div className={styles.titledate}>
            <span className={styles.title}>{event.name}</span>
            {date ? (
              <span className={styles.date}>
                {time ? `${date} в ${time}` : date}
              </span>
            ) : null}
          </div>

          <span className={styles.location}>
            <span>{event.place}</span>

            <span>{event.place_city}</span>
          </span>
        </div>

        <button className={styles.button}>
          <span className={styles.price}>
            {event.countTicketTypes > 1 ? "от " : ""}
            {event.price}
          </span>
        </button>
      </div>
    </div>
  );
};

export default MovieCard;
